<div class="document-history-modal">
  <div class="header">
    <h3 class="title" i18n>View Documents</h3>
    <div class="icon-wrapper">
      <a class="cancel-button" (click)="close()" tabindex="-1">
        <mat-icon>cancel</mat-icon>
      </a>
    </div>
  </div>
  <div class="content step-1">
    <ag-grid-angular
      class="ag-theme-cbre w-100 h-420"
      [animateRows]="false"  
      [columnDefs]="docsHistoryColumnDefs"        
      [defaultColDef]="docsHistoryDefaultColDef"
      [components]="cellRendererComponents"
      [autoSizeStrategy]="docsHistoryAutoSizeStrategy"
      [context]="context"
      [pagination]="true" 
      [rowData]="rowData"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
